import {
  type ClientSideDataProviderProps as SharedClientSideDataProviderProps,
  DataProvider as SharedDataProvider,
} from '@shared/ui/Table';
import type { RowData } from '@tanstack/react-table';
import type { AllTexts } from '@/feature/lang/types';
import { ConfigureColumnsAction } from './components/ConfigureColumns';

export interface ClientSideDataProviderProps<
  TData extends RowData,
> extends SharedClientSideDataProviderProps<TData, AllTexts> {
  enableColumnConfiguration?: boolean;
}

export const DataProvider = <TData extends RowData>({
  enableColumnConfiguration = false,
  toolbarControls,
  ...props
}: ClientSideDataProviderProps<TData>) => (
  <SharedDataProvider<TData, AllTexts>
    {...props}
    toolbarControls={
      enableColumnConfiguration ? (
        <>
          {toolbarControls}
          <ConfigureColumnsAction />
        </>
      ) : (
        toolbarControls
      )
    }
  />
);
